import React from 'react';
import '../../styles/CaseStudyFour/CaseStudiesResults4.css';
import productIcon1 from '../../assets/money-down.png';
import productIcon2 from '../../assets/money.png';
import productIcon3 from '../../assets/pink-star.png';

const CaseStudiesResults4 = () => {
  return (
    <section className="case-results-section4">
      <div className="case-results-container4">
        {/* Title */}
        <h2 className="case-results-title4">The Results</h2>

        {/* Product/Service Boxes */}
        <div className="winning-item-container4">
          <div className="winning-item-box4">
            <img src={productIcon1} alt="Winning Item 1" className="winning-product-icon4" />
            <p>Reduced Cost Per Move by 61%</p>
          </div>
          <div className="winning-item-box4">
            <img src={productIcon2} alt="Winning Item 2" className="winning-product-icon4" />
            <p>Increased Return on Adspend by 156%</p>
          </div>
          <div className="winning-item-box4">
            <img src={productIcon3} alt="Winning Item 3" className="winning-product-icon4" />
            <p>Increased Number of Moves Generated by 238%</p>
          </div>
        </div>

        {/* Description Text */}
        <ul className="case-results-description4">
          <li>Total Spend (Jan 2024 – Aug 2024): $19,940.39 generated 52 moves at $383.47 per move.</li>
          <li>Post-Implementation Spend: $9,551 generated 64 moves at $149.25 per move.</li>
          <li>Improved audience targeting and keyword refinement resulted in a 61% decrease in cost per move.</li>
        </ul>

      </div>
    </section>
  );
};

export default CaseStudiesResults4;